import { render, staticRenderFns } from "./AuditUsers.vue?vue&type=template&id=a659a68c&scoped=true&"
import script from "./AuditUsers.vue?vue&type=script&lang=js&"
export * from "./AuditUsers.vue?vue&type=script&lang=js&"
import style0 from "./AuditUsers.vue?vue&type=style&index=0&id=a659a68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a659a68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VSpacer,VTextField})
